module.exports = __webpack_public_path__ + "images/img0.png";